import { z } from "zod";

import { emailSchema } from "../account/auth.schema";

export const adminLoginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1),
});
export type AdminLoginInput = z.infer<typeof adminLoginSchema>;

export const adminRefreshSchema = z.object({
  refreshToken: z.string().min(1),
});
export type AdminRefreshInput = z.infer<typeof adminRefreshSchema>;

export const adminLogoutSchema = z.object({
  refreshToken: z.string().min(1),
});
export type AdminLogoutInput = z.infer<typeof adminLogoutSchema>;

export const adminMfaVerifySchema = z.object({
  mfaToken: z.string().min(1),
  code: z.string().min(6).max(8),
});
export type AdminMfaVerifyInput = z.infer<typeof adminMfaVerifySchema>;

export const adminMfaBackupVerifySchema = z.object({
  mfaToken: z.string().min(1),
  backupCode: z.string().min(8).max(32),
});
export type AdminMfaBackupVerifyInput = z.infer<typeof adminMfaBackupVerifySchema>;

export const adminMfaSetupConfirmSchema = z.object({
  mfaToken: z.string().min(1),
  code: z.string().min(6).max(8),
});
export type AdminMfaSetupConfirmInput = z.infer<typeof adminMfaSetupConfirmSchema>;

export const adminMfaTokenOnlySchema = z.object({
  mfaToken: z.string().min(1),
});
export type AdminMfaTokenOnlyInput = z.infer<typeof adminMfaTokenOnlySchema>;
